module.exports = __webpack_public_path__ + "static/media/country_mh.47318a96.webp";